import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Doughnut } from 'react-chartjs-2';
import { withStyles } from '@material-ui/core/styles';
import TypographyStyles from '../../../styles/typography';
import combineStyles from '../../../utils/combineStyles';
import classnames from 'classnames';

const styles = theme => ({
  metricLabelContainer: {
    transform: 'translate(-50%, -50%)',
    position: 'absolute',
    left: '50%',
    top: '50%',
    textAlign: 'center',
    '& p': {
      margin: 0
    }
  },
  chartContainer: {
    width: '150px',
    height: '150px',
    position: 'relative'
  },
  innerTitle: {
    fontFamily: theme.typography.font.second
  }
});
export class DonutChart extends Component {
  static propTypes = {
    data: PropTypes.array.isRequired,
    labels: PropTypes.array.isRequired,
    colors: PropTypes.array.isRequired,
    innerTitle: PropTypes.string.isRequired,
    innerText: PropTypes.string.isRequired
  };
  state = {
    config: {
      labels: this.props.labels,
      datasets: [
        {
          data: [],
          backgroundColor: this.props.colors
        }
      ]
    },
    options: {
      maintainAspectRatio: true,
      responsive: false,
      legend: {
        display: false
      },
      cutoutPercentage: 70
    },
    loading: false
  };
  render() {
    const { config, options } = this.state;
    const { data, labels, innerText, innerTitle, classes, colors } = this.props;
    config.datasets[0].data = data;
    config.datasets[0].backgroundColor = colors;
    config.labels = labels;
    return (
      <div className={classes.chartContainer}>
        <div className={classes.metricLabelContainer}>
          <p className={classnames(classes.subtitle3, classes.innerTitle)}>
            {innerText}
          </p>
          <p className={classes.caption}>{innerTitle}</p>
        </div>
        <Doughnut data={config} width={150} height={150} options={options} />
      </div>
    );
  }
}

export default withStyles(combineStyles(TypographyStyles, styles))(DonutChart);
